import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment, SERVER_URL } from './environments/environment'
import { registerLicense } from '@syncfusion/ej2-base'
import { oneTimeCacheBust } from './oneTimeCacheBust'
import * as Sentry from '@sentry/angular'

registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkxiXX5fc3NXTmdbVUw=')

if (environment.SENTRY_ENABLED) {
  Sentry.init({
    dsn: environment.SENTRY_DSN,
    // Brave Shields (or other adblockers) may block requests to sentry.io, so events go through our own backend
    tunnel: SERVER_URL + '/sentry-tunnel',
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  })
}

if (environment.production) {
  oneTimeCacheBust() // TODO: ASPIK-689 remove after 09/2025

  enableProdMode()
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err))
